import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ff as ffSelectors } from './ffSelectors';
import { userSelectors } from './userSelectors';
export const filterAvailableRoutes = (routes)=>(state)=>{
        const isVendor = userSelectors.isVendor(state);
        const role = userSelectors.role(state);
        const hasBusiness = userSelectors.hasBusiness(state);
        const ff = ffSelectors.featureFlagsData(state);
        const filterFn = (route)=>typeof route.shouldShow === 'function' ? route.shouldShow({
                isVendor,
                role,
                hasBusiness,
                ff
            }) : route.shouldShow;
        return routes.filter(filterFn).map((route)=>'items' in route ? _object_spread_props(_object_spread({}, route), {
                items: route.items.filter(filterFn)
            }) : route);
    };
